<template>
  <span @click="showModal()" data-title="Check Wallet Id">
    <button class="infobutton" href="#" tabindex="0">
      <font-awesome-icon
        class="fa-1x infoicon align-middle text-info"
        :icon="['fas', 'check-circle']"
      />
    </button>

    <b-modal
      ref="walletCheckModal"
      size="lg"
      centered
      scrollable
      hide-footer
      title="Check Wallet Id"
      @hidden="modalHidden"
    >
      <div class="form-group">
        <label for="walletid" class="form__label">Wallet Id</label>
        <input
          type="text"
          class="form-control"
          id="walletid"
          :value="curWalletId"
          disabled="disabled"
        />
      </div>
      <div class="form-group">
        <label for="curwalletid" class="form__label">Current Wallet Id</label>
        <div class="position-relative">
          <input type="text" class="form-control" id="curwalletid" v-model.trim="wallet_id" />
          <template v-if="wallet_id === curWalletId">
            <font-awesome-icon
              class="fa-1x infoicon align-middle text-success vicon"
              :icon="['fas', 'check-circle']"
            />
          </template>
          <template v-else>
            <font-awesome-icon
              class="fa-1x infoicon align-middle text-danger vicon"
              :icon="['fas', 'times-circle']"
            />
          </template>
        </div>
      </div>
    </b-modal>
  </span>
</template>

<script>
export default {
  name: "CheckWallet",
  props: ["curWalletId"],
  watch: {
    wallet_id(value) {
      if (value === this.curWalletId) {
        this.message = "Wallet Ids are same!";
      } else {
        this.message = "Wallet Ids doesn't match";
      }
    }
  },
  methods: {
    showModal() {
      this.$refs["walletCheckModal"].show();
    },
    modalHidden() {
      this.wallet_id = "";
    }
  },
  data() {
    return {
      wallet_id: ""
    };
  }
};
</script>

<style lang="scss" scoped>
.vicon {
  position: absolute;
  top: 8px;
  right: 8px;
}
</style>